import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, TextField } from '@mui/material'
import UnitAdornment from '@component/UnitAdornment'
import { useBasementWall } from './context'

function BasementWallResult () {
  const { t } = useTranslation()
  const { form, result } = useBasementWall()

  const hidden = !form.formState.isSubmitSuccessful

  const isHidden = (
    hidden
    || result === null
    || result === undefined
  )

  if (isHidden) return <></>

  const InputProps = {
    endAdornment: <UnitAdornment unit="mm" />,
  }

  const filteredThicknesses = result.thickness.filter(value => value > 0)
  const textFieldKey = 'tempKey'

  return (
    <Card>
      <CardHeader title={t('COMPOUND.RESULT', { label: 'GLOSSARY.BASEMENT_WALL' })} />
      <CardContent className="flex flex-col gap-16">
        {filteredThicknesses.map((thickness, index) => (
          <TextField
            key={textFieldKey}
            label={t(`GLOSSARY.B${index + 1}_FLOOR_THICKNESS`)}
            disabled
            InputProps={InputProps}
            value={thickness}
          />
        ))}
      </CardContent>
    </Card>
  )
}

export default BasementWallResult
